import React from "react";
import { EuiAccordion, EuiPanel } from "@elastic/eui";
import styled from "styled-components";

const StyledEuiAccordion = styled(EuiAccordion)`
    display: flex;
    width: 100%;
    flex-direction: column;
    *,
    *:hover {
        text-decoration: none !important ;
    }

    & .euiAccordion__triggerWrapper {
        background-color: ${(props) => props.backgroundColor || "white"};
        padding: ${(props) => props.padding || " 5px 0"};
        border-radius: 6px;

        button {
            span {
                text-transform: capitalize;
                color: ${(props) => props.arrowColor || "#198aa5"};
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 16px;
            }
            .euiAccordion__iconWrapper {
                order: 2;
            }
        }
    }
    & .euiAccordion__childWrapper {
        overflow: unset;
        & .euiPanel.euiPanel--subdued {
            background-color: ${(props) => props.backgroundColor || "white"};
        }
    }
`;

const StyledEuiPanel = styled(EuiPanel)`
    padding: 16px 0 !important;
`;

export default function AccordionComponent({
    id,
    body,
    title,
    defaultExpanded,
    extraAction,
    backgroundColor,
    arrowColor,
    padding,
}) {
    return (
        <StyledEuiAccordion
            id={id}
            arrowDisplay="left"
            extraAction={extraAction}
            buttonContent={title}
            initialIsOpen={defaultExpanded}
            backgroundColor={backgroundColor}
            arrowColor={arrowColor}
            padding={padding}
        >
            <StyledEuiPanel color="subdued">{body}</StyledEuiPanel>
        </StyledEuiAccordion>
    );
}
